interface Environment {
  getApiBaseUrl: () => string
  getReCaptchaSiteKey: () => string
  getAuth0Domain: () => string
  getAuth0ClientId: () => string
  getAuth0Audience: () => string
  getAuth0Realm: () => string
  getAuth0LoginRedirect: () => string
  getEnv: () => string
  getLaunchDarklyClientId: () => string
}

const getEnv = () => {
  if (window.location.hostname.includes("localhost")) {
    return "local"
  }
  switch (window.location.hostname) {
    case "referral.tranquility.app":
      return "production"
    case "referral-staging.tranquility.app":
      return "staging"
    case "referral-dev.tranquility.app":
      return "qa_dev"
    default:
      return "local"
  }
}

const isProduction = getEnv() === "production"
const isStaging = getEnv() === "staging"
const isQADev = getEnv() === "qa_dev"

const getApiBaseUrl = () => {
  if (isProduction) {
    return "https://referral-api.tranquility.app"
  }
  if (isStaging) {
    return "https://referral-api.staging.tranquility.app"
  }
  if (isQADev) {
    return "https://referral-api.dev.tranquility.app"
  }
  // Default local dev
  return "http://localhost:3030"
}

const getReCaptchaSiteKey = () => {
  if (isProduction) return "6Le6mtwiAAAAAAFG8Avvd9CWNjISBzfDaTfItPM6"
  return "6Lf5orYqAAAAAJWbSr7VcDphJ-RiWN5YrwzxTPUx"
}

const getAuth0Domain = () => "login.tranquility.app"

const getAuth0ClientId = () => {
  if (isProduction) return "ugcyMUs8KaZkWIcZZVE2CAVn7qmazn3c"
  return "18FUIXuXJ1GnNiXB1UEyQ9w6clfEN4Ch"
}

const getAuth0Audience = () => {
  if (isProduction) {
    return "https://referral-api.tranquility.app"
  }

  if (isStaging) {
    return "https://referral-api.staging.tranquility.app"
  }

  if (isQADev) {
    return "https://referral-api.staging.tranquility.app"
  }

  return "https://api.dev.tranquility.app"
}

const getAuth0Realm = () => {
  if (isProduction) return "TranquilityCanadian"
  return "TranquilityCanadianStaging"
}

const getAuth0LoginRedirect = () => {
  if (isProduction) {
    return "https://referral.tranquility.app/callback"
  }

  if (isStaging) {
    return "https://referral-staging.tranquility.app/callback"
  }

  if (isQADev) {
    return "https://referral-dev.tranquility.app/callback"
  }

  return "http://localhost:3031/callback"
}

const getLaunchDarklyClientId = () => {
  const LAUNCH_DARKLY_CLIENT_IDS = {
    dev: "66474fe0cf0b1710ccc509b0",
    staging: "669a7c3fe604620fd32436e4",
    production: "66474fe0cf0b1710ccc509b1",
  }

  if (isProduction) return LAUNCH_DARKLY_CLIENT_IDS["production"]

  if (isStaging) return LAUNCH_DARKLY_CLIENT_IDS["staging"]

  return LAUNCH_DARKLY_CLIENT_IDS["dev"]
}

export const EnvironmentService: Environment = {
  getApiBaseUrl,
  getReCaptchaSiteKey,
  getAuth0Domain,
  getAuth0ClientId,
  getAuth0Audience,
  getAuth0Realm,
  getAuth0LoginRedirect,
  getEnv,
  getLaunchDarklyClientId,
}
